import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular, brands, icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import VerticalSidebar from "./components/VerticalSidebar/VerticalSidebar";
import Places from "./components/Places/Places";
import Home from "./components/HomePanel/Home/Home";
import store from "./store/store";
import { Provider } from "react-redux";
// import MySectionList from "./components/VirtualSectionList/VirtualSectionList";
import SchedulePanel from "./components/SchedulePanel/SchedulePanel";
import MobileHeader from "./components/HomePanel/MobileHeader/MobileHeader";
import MobileBottomNavBar from "./components/HomePanel/MobileBottomNavBar/MobileBottomNavBar";
import MobileNavBar from "./components/HomePanel/MobileNavBar/MobileNavBar";
import WelcomeScreen from "./components/WelcomeScreen/WelcomeScreen";
import PlacesHeader from "./components/PlacesHeader/PlacesHeader";
import GuidesHeader from "./components/GuidesHeader/GuidesHeader";
import Guides from "./components/Guides/Guides";
import GuideDownloadComponent from "./components/modals/GuideDownload/GuideDownloadComponent";
import ReportGuideModal from "./components/modals/ReportGuideModal";
import RenameFollowUpModal from "./components/modals/RenameFollowUpModal";
import { installDevTestHooks } from "./devTestHooks";
import GeoCharts from "./components/modals/GeoCharts";
import YouPanel from "./components/HomePanel/YouPanel/YouPanel";

import ScheduleHeader from "./components/SchedulePanel/Header/ScheduleHeader";
import GuideNameBar from "./components/HomePanel/GuideNameBar/GuideNameBar";
import InstallPrompt from "./components/HomePanel/InstallPrompt/InstallPrompt";
import ConflictPreviewBanner, { CONFLICT_BANNER_HEIGHT } from "./components/ConflictPreviewBanner";
import Map from "./components/Map/Map";
// import HTMLReader from "./components/modals/HTMLReader";
import MenuModal from "./components/modals/MenuModal";
import AlertModal from "./components/modals/AlertModal";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { slice1Actions } from "./store/reducer";
import { useResizeDetector } from "react-resize-detector";
import { Helmet } from "react-helmet";
import DataBase, { logVisit } from "./dataBase/liquidGuides";
import Guide, { GuideAttributes } from "./Models/Guide";
import { DateTime } from "luxon";
import Schedule from "./Models/Schedule";
import PlacesModel from "./Models/Places";
import Offcanvas from "react-bootstrap/Offcanvas";
import DirectionsDialogComponent from "./components/modals/DirectionsDialogComponent";
//import ReactGA from "react-ga";
import ReactGA from "react-ga4";
import { parseBuildLink, buildLinkDestinations } from "./Common/buildLink";
import { parsePlanLink, buildPlanGuide, planExtraDestinations } from "./Common/planLink";

// Development-only helpers for the Playwright tests (see devTestHooks.js).
installDevTestHooks();

function App() {
  // const [HTMLReaderModal, setHTMLReaderModal] = useState(false);
  // const [HTMLContent, setHTMLContent] = useState("");
  // const [displayNone, setDisplayNone] = useState(false);
  const [_MobileMode, setMobileMode] = useState(() => window.innerWidth < 981);
  // Desktop-mode Home/Map vertical resize bar — holds drag state across the
  // document-level mousemove/mouseup listeners (not React state; these fire
  // far more often than a re-render should happen). --homeheight/--mapheight
  // start as the 3fr/2fr defaults from App.css's :root and are overwritten
  // with px values here once the user drags, then persisted so the split
  // survives a reload. Found/added 2026-09-14.
  const homeMapResizeRef = useRef(null);
  // Holds the latest handleAddPlacesFromGuides closure — the listener below is
  // registered once in the same early effect as the resize listener (before this
  // component's early `return null` guards further down), so it must not itself
  // be a hook referencing state that changes over time; the ref sidesteps that.
  const addPlacesFromGuidesRef = useRef(null);
  // Same ref-forwarding trick, same reason — see this ref's own comment
  // above. Holds the latest handleChooseCopyMode closure (defined later,
  // after the early `return null` guards below) so the openCopyGuideMode
  // listener can be registered in the early effect without itself being a
  // conditionally-called hook. Bridges GuideDownload.js's (desktop popup)
  // copy button to the same "choose Schedule vs Places, then merge" flow
  // GuideDownloadComponent's mobile-mode copy button already uses directly
  // as a prop — GuideDownload.js is rendered from several files that don't
  // have access to handleChooseCopyMode itself. Found 2026-09-24.
  const handleChooseCopyModeRef = useRef(null);
  const [AlertModalShow, setAlertModalShow] = useState(false);
  // "Import Places from Other Guides" last step (2026-10-20): its own small
  // dialog. The Visited and Bucket List questions used to reopen the shared
  // multiselect right after it closed, which got lost in some layouts —
  // the flow just stopped. { count } while open.
  const [importPlacesChoice, setImportPlacesChoice] = useState(null);
  const [importPlacesVisited, setImportPlacesVisited] = useState(false);
  const [importPlacesBucket, setImportPlacesBucket] = useState(false);
  const [AlertModalTitle, setAlertModalTitle] = useState("");
  const [AlertModalMessage, setAlertModalMessage] = useState("");
  const [AlertModalButtons, setAlertModalButtons] = useState([]);
  // const [CopyMode, setCopyMode] = useState("Schedule");
  // const [CopyGuideID, setCopyGuideID] = useState("xx");

  const dispatch = useDispatch();
  // let ShowHTMLReader = useSelector((state) => state.ShowHTMLReader);
  // let ShowMultiselect = useSelector((state) => state.ShowMultiselect);
  let GuideLoaded = useSelector((state) => state.GuideLoaded);
  let MapFullScreen = useSelector((state) => state.MapFullScreen);
  let HomeFullScreen = useSelector((state) => state.HomeFullScreen);
  // Reserves space for ConflictPreviewBanner's fixed-position overlay —
  // see that component's own comment for why it's fixed (not in normal
  // flow) and why the space-reservation happens here instead of there.
  let PreviewingConflictSnapshot = useSelector((state) => state.PreviewingConflictSnapshot);
  const conflictBannerPadding = PreviewingConflictSnapshot ? CONFLICT_BANNER_HEIGHT : 0;

  let CurrentAppScreen = useSelector((state) => state.CurrentAppScreen);
  let ShowWelcomeScreen = useSelector((state) => state.ShowWelcomeScreen);
  let GuidesOrPlaces = useSelector((state) => state.GuidesOrPlaces);
  let MobileMode = useSelector((state) => state.MobileMode);
  let user_info = useSelector((state) => state.user_info);
  const user_info_id = useSelector((state) => state.user_info_id);
  let GuideSortOption = useSelector((state) => state.GuideSortOption);
  let GuideDownloadMode = useSelector((state) => state.GuideDownloadMode);
  let GuideOrderBy = useSelector((state) => state.GuideOrderBy);
  let GuideOrderAscending = useSelector((state) => state.GuideOrderAscending);
  let GuideSettings = useSelector((state) => state.GuideSettings);
  let HideSchedule = useSelector((state) => state.HideSchedule);
  let HidePlaces = useSelector((state) => state.HidePlaces);
  let HideMap = useSelector((state) => state.HideMap);
  let HideHome = useSelector((state) => state.HideHome);
  let HideSideMenu = useSelector((state) => state.HideSideMenu);

  let GuideSearchText = useSelector((state) => state.GuideSearchText);
  let GuideCountriesSelected = useSelector((state) => state.GuideCountriesSelected);
  let GuideCitiesSelected = useSelector((state) => state.GuideCitiesSelected);
  let GuideLanguageSelected = useSelector((state) => state.GuideLanguageSelected);
  let GuideCountriesMineSelected = useSelector((state) => state.GuideCountriesMineSelected);
  let GuideCitiesMineSelected = useSelector((state) => state.GuideCitiesMineSelected);
  let GuideLanguageMineSelected = useSelector((state) => state.GuideLanguageMineSelected);

  let guide_meta = useSelector((state) => state.guide_meta);
  let GuideInfoArray = useSelector((state) => state.GuideInfoArray);
  let GuideInfoArrayMine = useSelector((state) => state.GuideInfoArrayMine);
  let ViewedGuides = useSelector((state) => state.ViewedGuides);
  let GuideType = useSelector((state) => state.GuideType);
  let ScheduleNames = useSelector((state) => state.ScheduleNames);
  let ShowOffcanvas = useSelector((state) => state.ShowOffcanvas);

  //window.addEventListener("load", handleLoad);

  useEffect(() => {
    const isMobile = window.innerWidth < 981;
    dispatch(slice1Actions.setMobileMode({ value: isMobile }));
    window.addEventListener("resize", reportWindowSize);
    // Restore a previously dragged Home/Map split (see
    // handleHomeMapResizeStart) — same --homeheight/--mapheight vars the
    // drag itself sets, so a reload doesn't silently reset back to 3fr/2fr.
    try {
      const saved = JSON.parse(localStorage.getItem("home_map_split"));
      if (saved?.homeheight) document.documentElement.style.setProperty("--homeheight", saved.homeheight);
      if (saved?.mapheight) document.documentElement.style.setProperty("--mapheight", saved.mapheight);
      ensureHomeMapResizeBarVisible();
    } catch (e) { /* no saved split, or localStorage unavailable — keep CSS defaults */ }
    const addPlacesFromGuidesListener = () => {
      if (addPlacesFromGuidesRef.current) addPlacesFromGuidesRef.current();
    };
    window.addEventListener("addPlacesFromGuides", addPlacesFromGuidesListener);
    const openCopyGuideModeListener = (e) => {
      if (handleChooseCopyModeRef.current) handleChooseCopyModeRef.current(e?.detail?.guide_info_id);
    };
    window.addEventListener("openCopyGuideMode", openCopyGuideModeListener);
    return () => {
      window.removeEventListener("resize", reportWindowSize);
      window.removeEventListener("addPlacesFromGuides", addPlacesFromGuidesListener);
      window.removeEventListener("openCopyGuideMode", openCopyGuideModeListener);
    };
  }, []);

  // First-visit funnel: one "visit" per tab session (see liquidGuides.js).
  useEffect(() => {
    logVisit();
  }, []);

  // "Plan this city in the app" links from the website's Trip Builder (?build=City,Country:days;…,
  // Common/buildLink.js): once the app has started, open Build My Trip with those destinations as a new
  // guide. The layout on screen (HomeHeader on wide screens, MobileBottomNavBar on narrow) listens.
  useEffect(() => {
    const parsed = parseBuildLink(window.location.search);
    if (!parsed) return;
    const t = setTimeout(() => window.dispatchEvent(new CustomEvent("openBuildMyTripWizard", { detail: { buildLink: buildLinkDestinations(parsed) } })), 4000);
    return () => clearTimeout(t);
  }, []);

  // "Continue in the app" links from the Trip Builder (?plan=…, Common/planLink.js): the trip exactly as the
  // visitor arranged it, opened as a new guide built from its Featured city guides (2026-11-01); nothing is
  // saved until Save. 2026-11-03: the usual start guide isn't opened first any more (planLinkPending in the
  // headers), so the trip opens as soon as its city guides are read, with the loading indicator meanwhile.
  useEffect(() => {
    const parsed = parsePlanLink(window.location.search);
    if (!parsed) return;
    const ids = [...new Set(parsed.visits.map((v) => v.gid))];
    const guides = {};
    let left = ids.length, done = false;
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    const open = () => {
      if (done || left > 0) return;
      done = true;
      window.__planLinkDone = true;
      dispatch(slice1Actions.SetLoadingGuide({ value: false }));
      const data = buildPlanGuide(parsed, guides);
      const GuideObj = new Guide("new");
      if (!data || GuideObj.decodeGuideFb(data, data.attributes) !== true) {
        loadGuide("IQrZiedo7oJWa9GgLR6L"); // the start guide was skipped: open the default one
        setAlertModalTitle("Trip not found");
        setAlertModalMessage("The trip from the Trip Builder could not be opened. Its city guides may have changed; please build it again on the website.");
        setAlertModalButtons([{ Title: "OK", Method: null }]);
        setAlertModalShow(true);
        return;
      }
      window.__guideLoadGen = (window.__guideLoadGen || 0) + 1; // drop any guide still loading
      GuideObj.schedule.getPlaces_InSchedule();
      // the Home page: the trip's itinerary, as Build My Trip writes it for a new guide
      GuideObj.document = `<p><h3>${data.attributes.guide_name}</h3></p></br>${GuideObj.createHTMLItinerary("Main", { info: true, photo: true, directions: true, place_menu: true, eventBody: false })}`;
      window.guide_obj = GuideObj;
      if (!user_info?.uid || user_info.uid === "guest") window.guest_generated_unsaved_trip = true;
      dispatch(slice1Actions.setGuide({ guide: "new", guide_meta: { guide_info: null, guide_info_id: null, guide_id: null } }));
      dispatch(slice1Actions.setGuide({ guide: null, guide_meta: {} })); // the name bar reads the guide's name
      dispatch(slice1Actions.setHideSchedule({ value: false }));
      dispatch(slice1Actions.setGuidesOrPlaces({ value: "Places", GuideType: "None" }));
      dispatch(slice1Actions.setScheduleName({ value: "Main" }));
      dispatch(slice1Actions.resetHomeScreen({ value: null }));
      dispatch(slice1Actions.setGuideHasUnsavedChanges({ value: true }));
      setTimeout(fitPlaces, 1000);
      // days beyond a city's ready-made guide: Build My Trip plans them, added to this trip (2026-11-01)
      const extras = planExtraDestinations(parsed, guides);
      const more = extras.length ? ` Build My Trip opens next to plan the ${extras.map((d) => d.city).join(", ")} days the ready-made guide${extras.length > 1 ? "s don't" : " doesn't"} cover.` : "";
      setAlertModalTitle("Your trip");
      setAlertModalMessage(`"${data.attributes.guide_name}" from the Trip Builder is open as a new guide, with every stop on its day and time.${more} It isn't saved yet: save the guide to keep it. Once saved, it's also in the Andiamo mobile app under your guides, ready for the trip.`);
      setAlertModalButtons([{ Title: "OK", Method: extras.length ? () => window.dispatchEvent(new CustomEvent("openBuildMyTripWizard", { detail: { buildLink: extras, addToGuide: true } })) : null }]);
      setAlertModalShow(true);
    };
    ids.forEach((id) =>
      DataBase.readGuideTransaction(id, (res) => {
        if (res.pass === true) { try { guides[id] = JSON.parse(res.res.data); } catch (e) { /* left out */ } }
        left--;
        open();
      }, user_info?.uid || "guest", { peek: true })
    );
    // a read that never answers mustn't leave the app with no guide: open with what has arrived
    const t = setTimeout(() => { left = 0; open(); }, 15000);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
    // ReactGA.initialize("UA-252264346-1");
    // ReactGA.pageview(window.location.pathname + window.location.search);
  }, [GuideSettings]);

  if (new URLSearchParams(window.location.search).get("privacy") !== null) {
    window.location.replace("/Docs/privacy-policy.html");
    return null;
  }
  if (new URLSearchParams(window.location.search).get("terms") !== null) {
    window.location.replace("/Docs/terms-of-use.html");
    return null;
  }

  window.loadGuide = loadGuide;
  function loadGuide(guide_info_id) {
    //const guide_info_id = "wHvagurBLMmZ6zt4Cw6z"; // Imperia
    //const guide_info_id = "IQrZiedo7oJWa9GgLR6L"; // Florence
    window.record_last_guide_read = true;
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    setTimeout(timeoutFunc, 5000);
    DataBase.readGuideTransaction(guide_info_id, readGuideDataReturnNew, user_info.uid);
  }

  const timeoutFunc = () => {
    dispatch(slice1Actions.SetLoadingGuide({ value: false }));
  };

  const readGuideDataReturnNew = (res) => {
    let GuideObj = null;
    if (res.pass === true) {
      GuideObj = new Guide(res.guide_id);
      const guide_json = res.res.data;
      console.log(`Guide Size is: ${guide_json.length}`);
      var guide_obj;
      try { guide_obj = JSON.parse(guide_json); } catch (e) { console.log("JSON.parse error", e); }
      const decoded = guide_obj != null ? GuideObj.decodeGuideFb(guide_obj, res.infoDoc) : false;
      if (decoded === true) {
        GuideObj.schedule.getPlaces_InSchedule();
        window.guide_obj = GuideObj;
        dispatch(
          slice1Actions.setGuide({
            guide: "new",
            guide_meta: { guide_info: res.infoDoc, guide_info_id: res.guide_info_id, guide_id: res.guide_id },
          })
        );
        dispatch(slice1Actions.setCreatorInfo({ value: res.creator_info }));
        dispatch(slice1Actions.setOwnerInfo({ value: res.owner_info }));
        dispatch(slice1Actions.pushGuideStack({ value: res.guide_info_id }));
        dispatch(slice1Actions.addViewedGuide({ id: res.guide_info_id, data: res.infoDoc }));
        dispatch(slice1Actions.setHideSchedule({ value: false }));
        dispatch(slice1Actions.setGuidesOrPlaces({ value: "Places", GuideType: "None" }));
        setTimeout(fitPlaces, 1000);
        if (window.record_last_guide_read === true && user_info.uid !== "guest") {
          window.record_last_guide_read = false;
          recordLastGuideRead(res.guide_info_id);
        }
        // dispatch(slice1Actions.setGuideInfo({ value: res.infoDoc }));
        // dispatch(slice1Actions.setAuthorization({ guide_info: res.infoDoc, uid: user_info.uid }));
        //dispatch(slice1Actions.setOwnerInfo({ value: res.user_info }));
        //console.log(res.owner_info);
      } else {
        console.log("decode failed");
      }
    } else {
      //console.log(res.res);
    }
    window.record_last_guide_read = false;
    dispatch(slice1Actions.SetLoadingGuide({ value: false }));
  };

  const recordLastGuideRead = (guide_info_id) => {
    // Guests have no cloud user profile to persist this to — DataBase's
    // guest guard would reject the write anyway, but with an intrusive
    // "Guest Mode / Saving to the cloud..." alert, which is wrong here: this
    // is passive background bookkeeping (remembering the last guide viewed)
    // that fires on every guide load, not something the user asked to save.
    if (user_info === null || user_info.uid === "guest") return;
    let _user_info = JSON.parse(JSON.stringify(user_info));
    _user_info.last_guide_id = guide_info_id;
    _user_info.last_guide_time = DateTime.utc().toISO();
    dispatch(slice1Actions.setUserInfo({ value: _user_info }));
    DataBase.updateUser(_user_info, user_info_id || _user_info.uid, updateUserCallback);
  };

  const updateUserCallback = (res) => {
    console.log("updateUserCallback", res.pass);
  };
  const fitPlaces = (user) => {
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };
  // const onAuthStateChanged = (user) => {
  //   console.log("onAuthStateChanged", user);
  //   if (user) {
  //     User.findUserByUID(user.uid, findUserByUIDCallback);
  //   } else {
  //     const parsed = queryString.parse(window.location.search);
  //     let guide_to_load = "IQrZiedo7oJWa9GgLR6L";
  //     if (typeof parsed.id != "undefined") guide_to_load = parsed.id;
  //     loadGuide(guide_to_load);
  //   }
  // };

  // let MultiselectItems = useSelector((state) => state.MultiselectItems);
  // let MultiselectSelectedItems = useSelector((state) => state.MultiselectSelectedItems);
  // let MultiselectMode = useSelector((state) => state.MultiselectMode);
  // let MultiselectSearchText = useSelector((state) => state.MultiselectSearchText);
  // let MultiselectTitle = useSelector((state) => state.MultiselectTitle);
  // let MultiselectCallback = useSelector((state) => state.MultiselectCallback);

  // if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  //   MobileMode = true;
  // }
  // const { width, height, ref } = useResizeDetector();
  // useEffect(() => {
  //   //const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
  //   MobileMode = width < 760 ? true : false;
  // }, [width]);
  const SetGuideSortOption = () => {};

  const handleChooseCopyMode = (guide_info_id) => {
    // setCopyGuideID(guide_info_id);
    window.CopyGuideID = guide_info_id;
    const copy_modes = [
      { label: "Schedule", value: "Schedule" },
      { label: "Places", value: "Places" },
    ];
    dispatch(slice1Actions.setMultiselectCallback({ value: ChooseCopyModeCallBack }));
    dispatch(slice1Actions.setMultiselectItems({ value: copy_modes }));
    dispatch(slice1Actions.setMultiselectSelectedItems({ value: "" }));
    dispatch(slice1Actions.setMultiselectMode({ value: "uni" }));
    dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    dispatch(slice1Actions.setMultiselectTitle({ value: "Select What to Copy" }));
    dispatch(slice1Actions.setShowMultiselect({ value: true }));
  };
  handleChooseCopyModeRef.current = handleChooseCopyMode;

  const ChooseCopyModeCallBack = (copy_modes) => {
    if (copy_modes.length > 0) {
      window.copyMode = copy_modes[0].label;
      //setCopyMode(copy_modes[0].label);
      CopyFromGuideCallback(window.CopyGuideID);
    }
  };

  const CopyFromGuideCallback = (guide_info_id) => {
    console.log("CopyFromGuideCallback");
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    setTimeout(timeoutFunc, 5000);
    DataBase.readGuideTransaction(guide_info_id, readGuideDataReturnCopy, user_info.uid);
  };

  const readGuideDataReturnCopy = (res) => {
    let GuideObj = null;
    if (res.pass === true) {
      GuideObj = new Guide(res.guide_id);
      const guide_json = res.res.data;
      console.log(`Guide Size is: ${guide_json.length}`);
      var guide_obj;
      try { guide_obj = JSON.parse(guide_json); } catch (e) { console.log("JSON.parse error", e); }
      const decoded = guide_obj != null ? GuideObj.decodeGuideFb(guide_obj, res.infoDoc) : false;
      if (decoded === true) {
        GuideObj.schedule.getPlaces_InSchedule();
        window.guide_obj_copy = GuideObj;
        if (window.copyMode === "Schedule") {
          handleChooseSchedule();
          // setTimeout(() => {
          //   handleChooseSchedule();
          // }, 100);
        } else {
          handleChoosePlaces();
          // setTimeout(() => {
          //   handleChoosePlaces();
          // }, 100);
        }
        // dispatch(
        //   slice1Actions.setGuide({
        //     guide: "new",
        //     guide_meta: { guide_info: res.infoDoc, guide_info_id: res.guide_info_id, guide_id: res.guide_id },
        //   })
        // );
        // dispatch(slice1Actions.setCreatorInfo({ value: res.creator_info }));
        // dispatch(slice1Actions.setOwnerInfo({ value: res.owner_info }));
        // dispatch(slice1Actions.pushGuideStack({ value: res.guide_info_id }));
        // dispatch(slice1Actions.setHideSchedule({ value: false }));
        // dispatch(slice1Actions.setGuidesOrPlaces({ value: "Places", GuideType: "None" }));
        // setTimeout(fitPlaces, 1000);
        // if (window.record_last_guide_read === true && user_info.uid !== "guest") {
        //   window.record_last_guide_read = false;
        //   recordLastGuideRead(res.guide_info_id);
        // }
      } else {
        console.log("decode failed");
      }
    } else {
      //console.log(res.res);
    }
    dispatch(slice1Actions.SetLoadingGuide({ value: false }));
  };

  const handleChooseSchedule = () => {
    const schedulenames = window.guide_obj_copy.schedule.geScheduleNames();
    dispatch(slice1Actions.setMultiselectCallback({ value: chooseScheduleCallBack }));
    dispatch(slice1Actions.setMultiselectItems({ value: schedulenames }));
    dispatch(slice1Actions.setMultiselectSelectedItems({ value: "" }));
    dispatch(slice1Actions.setMultiselectMode({ value: "uni" }));
    dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    dispatch(slice1Actions.setMultiselectTitle({ value: "Select Schedule" }));
    dispatch(slice1Actions.setShowMultiselect({ value: true }));
  };

  const chooseScheduleCallBack = (schedules) => {
    if (schedules.length > 0) {
      console.log("schedules[0].label", schedules[0].label);
      copySchedule(schedules[0].label);
    }
  };

  const copySchedule = (schedule_name) => {
    // Tie every copied schedule's new name to the guide it came from, not
    // just "Main"'s — a bare schedule name like "Day 1" collides easily with
    // an identically-named schedule already in the destination guide, and
    // the counter-suffix fallback below ("Day 1" -> "Day 145") loses all
    // context about which guide it was actually copied from. Requested
    // 2026-09-27.
    const sourceGuideName = (window.guide_obj_copy.attributes?.guide_name || "").trim();
    let rawName;
    if (schedule_name === "Main") {
      rawName = sourceGuideName || schedule_name;
    } else if (sourceGuideName) {
      // Reserve only part of the 20-char cap for the guide name so a long
      // guide name can't eat the whole budget and truncate away the actual
      // distinguishing schedule name (e.g. "Day 1"), which would defeat the
      // point and just push every copy from that guide into the ugly
      // counter-suffix fallback below instead.
      rawName = `${sourceGuideName.substring(0, 12)}: ${schedule_name}`;
    } else {
      rawName = schedule_name;
    }
    let baseName = rawName.replace(/[,]+$/, "").trimEnd().substring(0, 20).replace(/[,]+$/, "").trimEnd();

    // Find a unique schedule name (group name matches it without _m suffix)
    const existingScheduleNames = window.guide_obj.schedule.geScheduleNames().map((s) => s.label.toLowerCase());
    const existingGroupNames = window.guide_obj.groups.map((g) => g.name.toLowerCase());
    let uniqueBase = baseName;
    let counter = 1;
    while (
      existingGroupNames.includes(uniqueBase.toLowerCase()) ||
      existingScheduleNames.includes(uniqueBase.toLowerCase())
    ) {
      uniqueBase = baseName.substring(0, 18) + counter;
      counter++;
    }
    const groupName = uniqueBase;
    const destScheduleName = uniqueBase;

    // Copy events and collect new place IDs
    let events = window.guide_obj_copy.schedule.getEventsFromSchedule(schedule_name);
    let allNewPlaceIds = [];
    // Tracks each copied place's ORIGINAL (source guide) Place object, so
    // its source mosaic-group membership can be recreated below — a place
    // only carries its own new .Group array at that point, not what it used
    // to belong to in the source guide. A plain object, not `new Map()` —
    // this file imports a REACT COMPONENT named Map (./components/Map/Map),
    // which shadows the built-in Map class here; `new Map()` was actually
    // instantiating that component directly, outside React's render cycle
    // ("Invalid hook call" crash). Found 2026-09-27.
    const newIdToSourcePlace = {};
    for (let i = 0; i < events.length; i++) {
      let new_place_ids = [];
      let event_place_ids = events[i].Places ? events[i].Places.split(",") : [];
      for (let j = 0; j < event_place_ids.length; j++) {
        const event_place = window.guide_obj_copy.places.getPlace(event_place_ids[j].trim());
        if (event_place === null) continue;
        let new_id = "";
        const similar_place = window.guide_obj.places.getSimilarPlaceInGuide(event_place);
        if (similar_place !== null) new_id = similar_place.ID;
        else new_id = window.guide_obj.places.addPlace(event_place);
        new_place_ids.push(new_id);
        if (!allNewPlaceIds.includes(new_id)) {
          allNewPlaceIds.push(new_id);
          newIdToSourcePlace[new_id] = event_place;
        }
      }
      const newEvent = { ...events[i], Places: new_place_ids.join(","), Itinerary: destScheduleName };
      window.guide_obj.schedule.addEvent(newEvent);
    }

    // Recreate the source guide's own per-place mosaic groups (e.g. one
    // group per destination/city within the copied schedule) instead of
    // only ever lumping every copied place into a single flat group — that
    // discarded the source's actual mosaic grouping entirely. Reported
    // 2026-09-27 as "mosaic groups were not recreated at all". Plain object,
    // not `new Map()` — see newIdToSourcePlace's comment above.
    const sourceGroupIdToDestGroupId = {};
    const getOrCreateDestGroupForSourceGroup = (sourceGroup) => {
      if (sourceGroupIdToDestGroupId[sourceGroup.id] != null) return sourceGroupIdToDestGroupId[sourceGroup.id];
      const existing = window.guide_obj.findGroupFromName(sourceGroup.name);
      let destGroupId;
      if (existing !== null && existing.mosaic && existing.schedule === destScheduleName) {
        destGroupId = existing.id;
      } else {
        // Local to each source group being disambiguated, not shared across
        // the whole copy — a shared counter meant disambiguating an earlier
        // group (e.g. "Rome" -> "Rome-2") bumped it as a side effect, so the
        // NEXT group's own disambiguation (e.g. "Florence") started from
        // that already-bumped value and skipped straight to "Florence-3"
        // instead of "Florence-2". Found 2026-09-27.
        let destGroupName = sourceGroup.name;
        let groupNameCounter = 2;
        while (window.guide_obj.findGroupFromName(destGroupName) !== null) {
          destGroupName = `${sourceGroup.name}-${groupNameCounter}`;
          groupNameCounter++;
        }
        destGroupId = window.guide_obj.addGroup(destGroupName);
        const destGroup = window.guide_obj.groups.find((g) => g.id === destGroupId);
        if (destGroup) {
          destGroup.schedule = destScheduleName;
          destGroup.mosaic = true;
          destGroup.poi_img = 16;
          if (sourceGroup.image) destGroup.image = sourceGroup.image;
        }
      }
      sourceGroupIdToDestGroupId[sourceGroup.id] = destGroupId;
      return destGroupId;
    };

    // Flat, trip-wide group for the whole copied schedule — every copied
    // place gets tagged into this one regardless, same as
    // BuildMyTripWizard.js's own per-destination-group-plus-trip-wide-group
    // pattern, so the mosaic still shows one overall tile for the copied
    // schedule even alongside its recreated per-place groups.
    const groupId = window.guide_obj.addGroup(groupName);
    const tripGroup = window.guide_obj.groups.find((g) => g.id === groupId);
    if (tripGroup) { tripGroup.schedule = destScheduleName; tripGroup.mosaic = true; tripGroup.poi_img = 16; }
    for (const pid of allNewPlaceIds) {
      const p = window.guide_obj.places.getPlace(pid);
      if (p === null) continue;
      if (!Array.isArray(p.Group)) p.Group = [];
      if (!p.Group.includes(groupId)) p.Group.push(groupId);
      const sourcePlace = newIdToSourcePlace[pid];
      const sourceGroupIds = Array.isArray(sourcePlace?.Group) ? sourcePlace.Group : [];
      for (const sourceGroupId of sourceGroupIds) {
        const sourceGroup = window.guide_obj_copy.groups.find((g) => g.id === sourceGroupId);
        if (!sourceGroup || sourceGroup.mosaic !== true) continue;
        const destGroupId = getOrCreateDestGroupForSourceGroup(sourceGroup);
        if (!p.Group.includes(destGroupId)) p.Group.push(destGroupId);
      }
    }

    dispatch(slice1Actions.setHideSchedule({ value: false }));
    dispatch(slice1Actions.setScheduleName({ value: destScheduleName }));
    dispatch(slice1Actions.setGuidesOrPlaces({ value: "Places", GuideType: "Mine" }));
    // Everything above (addEvent, addGroup, addPlace) mutates window.guide_obj
    // directly, not Redux state — without this, derived state like
    // ScheduleNames (read by ScheduleHeader.js's "Choose Schedule" menu) and
    // the map/places lists stayed stale until some LATER, unrelated action
    // happened to force a refresh, making the copy look like it silently did
    // nothing (or the new schedule not show up in the picker) even though it
    // had actually succeeded. Matches the refresh dispatch every other
    // guide-mutating flow in this app already uses. Found 2026-09-27.
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
    // setGuide alone doesn't regenerate the Photo Mosaic Home content
    // (state.homeScreen) for a plain guide:null dispatch — only
    // resetHomeScreen does that. Without this, the new schedule's tile only
    // showed up after fully exiting and re-entering Mosaic mode. Explicit
    // scheduleName: "Main" override — state.ScheduleName was just set to
    // destScheduleName above (for Places/Map filtering), but landing on
    // that specific schedule's own single-schedule sub-page (with its own
    // hero image) right after copying was surprising; the user expects the
    // top-level Main overview grid, which now includes the new schedule's
    // tile. Found 2026-09-27.
    dispatch(slice1Actions.resetHomeScreen({ value: null, scheduleName: "Main" }));

    // Prompt to mark places as Visited, then separately whether to add them
    // to the Bucket List too — independent flags, not mutually exclusive.
    setAlertModalTitle("Mark as Visited");
    setAlertModalMessage(`Mark the ${allNewPlaceIds.length} copied place(s) as Visited?`);
    setAlertModalButtons([
      {
        Title: "Yes",
        Method: () => {
          for (const pid of allNewPlaceIds) {
            const p = window.guide_obj.places.getPlace(pid);
            if (p !== null) p.Visited = true;
          }
          askCopyScheduleBucketList(allNewPlaceIds, destScheduleName);
        },
      },
      { Title: "No", Method: () => askCopyScheduleBucketList(allNewPlaceIds, destScheduleName) },
    ]);
    setAlertModalShow(true);
  };

  const askCopyScheduleBucketList = (allNewPlaceIds, destScheduleName) => {
    setAlertModalTitle("Add to Bucket List");
    setAlertModalMessage(`Add the ${allNewPlaceIds.length} copied place(s) to your Bucket List too?`);
    setAlertModalButtons([
      {
        Title: "Yes",
        Method: () => {
          for (const pid of allNewPlaceIds) {
            const p = window.guide_obj.places.getPlace(pid);
            if (p !== null) p.BucketList = true;
          }
          finishCopySchedule(destScheduleName);
        },
      },
      { Title: "No", Method: () => finishCopySchedule(destScheduleName) },
    ]);
    setAlertModalShow(true);
  };

  const finishCopySchedule = (destScheduleName) => {
    const gs = window.guide_obj.guide_settings;
    const it = gs ? gs.itinerary : null;
    const isMosaic = it && it.directions === false && it.info === false && it.photo === true && it.place_menu === false;
    if (isMosaic) {
      const html = window.guide_obj.createHTMLItinerary("Main", it);
      dispatch(slice1Actions.setHTMLTitle({ value: "Itinerary" }));
      dispatch(slice1Actions.setHomeScreen({ value: html }));
    }
    setTimeout(() => refreshGuide(), 100);
  };

  const refreshGuide = () => {
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };

  const handleChoosePlaces = () => {
    const places = window.guide_obj_copy.places.getPlaces();
    let placesList = [];
    for (let i = 0; i < places.length; i++) {
      placesList.push({ label: places[i].Name, value: places[i] });
    }
    dispatch(slice1Actions.setMultiselectCallback({ value: choosePlacesCallBack }));
    dispatch(slice1Actions.setMultiselectItems({ value: placesList }));
    dispatch(slice1Actions.setMultiselectSelectedItems({ value: "" }));
    dispatch(slice1Actions.setMultiselectMode({ value: "multi" }));
    dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    dispatch(slice1Actions.setMultiselectTitle({ value: "Select Places" }));
    dispatch(slice1Actions.setShowMultiselect({ value: true }));
  };

  const choosePlacesCallBack = (places) => {
    if (places.length > 0) {
      for (let i = 0; i < places.length; i++) {
        const similar_place = window.guide_obj.places.getSimilarPlaceInGuide(places[i].value);
        if (similar_place === null) {
          const place = window.guide_obj_copy.places.getPlace(places[i].value.ID);
          if (place !== null) window.guide_obj.places.addPlace(place);
        }
      }
      dispatch(slice1Actions.setHideSchedule({ value: false }));
      dispatch(slice1Actions.setGuidesOrPlaces({ value: "Places", GuideType: "Mine" }));
      setTimeout(() => {
        refreshGuide();
      }, 100);
    }
  };

  // "Add places from another guide" — usability-recommendations.md rec #9. Unlike
  // "Copy from Guide" above (one source guide, picked from a guide card), this scans
  // several guides at once: pick which of the user's own guides to scan (default all),
  // then a single deduped places list to choose from. Places already present in the
  // current guide (by exact Lat/Longi/Name match, via getSimilarPlaceInGuide) are
  // excluded automatically, both against the current guide and against each other.
  const handleAddPlacesFromGuides = () => {
    if (!window.guide_obj) {
      // The one silent early-return in this flow — every other exit path
      // shows an alert, so this looked exactly like "nothing happened" when
      // it fired. Log so it's diagnosable, and tell the user rather than
      // silently doing nothing.
      console.log("handleAddPlacesFromGuides: window.guide_obj is not set");
      setAlertModalTitle("No Guide Open");
      setAlertModalMessage("Open a guide first, then try again.");
      setAlertModalButtons([{ Title: "OK", Method: null }]);
      setAlertModalShow(true);
      return;
    }
    // Guests may do everything except write to the cloud (2026-10-20):
    // having no saved guides of their own, they scan Featured guides
    // (it used to query their own as "guest" and silently do nothing).
    const isGuest = !user_info || user_info.uid === "guest";
    // GuideInfoArrayMine is only populated after the user visits the My Guides
    // library screen (App.js SaveGuides callback) — it's empty on a fresh
    // session that goes straight into a guide, which made this silently show
    // "no other guides" every time. Fetch straight from Firestore instead of
    // trusting that cache.
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    DataBase.getAllGuideInfo(user_info?.uid, (res) => {
      dispatch(slice1Actions.SetLoadingGuide({ value: false }));
      if (res.pass !== true) {
        setAlertModalTitle("Error");
        setAlertModalMessage("Could not load your guides. Please try again.");
        setAlertModalButtons([{ Title: "OK", Method: null }]);
        setAlertModalShow(true);
        return;
      }
      const guides = window.guide_obj.classifyAuthorization(res.res, user_info.uid);
      const otherGuides = (guides || []).filter(
        (g) => g.data?.guide_id !== window.guide_obj.guide_id && (isGuest || g.data?.user_id === user_info.uid)
      );
      if (otherGuides.length === 0) {
        setAlertModalTitle("No Other Guides");
        setAlertModalMessage("You don't have any other guides to add places from.");
        setAlertModalButtons([{ Title: "OK", Method: null }]);
        setAlertModalShow(true);
        return;
      }
      const items = otherGuides
        .map((g) => ({ label: g.data.guide_name, value: g.id }))
        .sort((a, b) => (isGuest ? a.label.localeCompare(b.label) : 0));
      dispatch(slice1Actions.setMultiselectCallback({ value: guidesToScanCallback }));
      dispatch(slice1Actions.setMultiselectItems({ value: items }));
      // Featured guides number in the hundreds: nothing ticked to start.
      dispatch(slice1Actions.setMultiselectSelectedItems({ value: isGuest ? [] : items }));
      dispatch(slice1Actions.setMultiselectMode({ value: "multi" }));
      dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
      dispatch(slice1Actions.setMultiselectTitle({ value: isGuest ? "Select Featured Guides to Scan" : "Select Guides to Scan" }));
      dispatch(slice1Actions.setShowMultiselect({ value: true }));
    }, isGuest ? "Featured" : "Mine");
  };

  const guidesToScanCallback = (selectedGuides) => {
    if (!selectedGuides || selectedGuides.length === 0) return;
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    const guideInfoIds = selectedGuides.map((g) => g.value);
    let remaining = guideInfoIds.length;
    const candidatePlaces = new PlacesModel();
    guideInfoIds.forEach((guide_info_id) => {
      DataBase.readGuideTransaction(
        guide_info_id,
        (res) => {
          if (res.pass === true) {
            try {
              const guide_json = JSON.parse(res.res.data);
              const scannedPlaces = new PlacesModel();
              scannedPlaces.decodePlaces(null, null, null, null, guide_json);
              scannedPlaces.placesList.forEach((p) => {
                if (
                  candidatePlaces.getSimilarPlaceInGuide(p) === null &&
                  window.guide_obj.places.getSimilarPlaceInGuide(p) === null
                ) {
                  candidatePlaces.placesList.push(p);
                }
              });
            } catch (e) {
              console.log("Error scanning guide for places:", e.message);
            }
          }
          remaining -= 1;
          if (remaining === 0) {
            fillMissingCountries(candidatePlaces.placesList).then((places) => {
              dispatch(slice1Actions.SetLoadingGuide({ value: false }));
              openAddPlacesPicker(places);
            });
          }
        },
        user_info.uid
      );
    });
  };

  // Wanderlist's country/continent stats need every place to have a Country —
  // guides built before that mattered (or places dragged onto the map rather
  // than searched) can be missing it. Reverse-geocode from Lat/Longi to fill
  // the gap for any candidate that needs it, before the user picks which to add.
  const reverseGeocodeCountry = async (lat, lng) => {
    try {
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.REACT_APP_GOOGLE_MAPS_GEOCODING_KEY}`
      );
      const json = await res.json();
      for (const result of json.results || []) {
        const countryComponent = (result.address_components || []).find((c) => c.types.includes("country"));
        if (countryComponent) return countryComponent.long_name;
      }
    } catch (e) {
      console.log("reverseGeocodeCountry error:", e.message);
    }
    return "";
  };

  const fillMissingCountries = async (places) => {
    const needsCountry = places.filter((p) => !p.Country || p.Country.trim() === "");
    await Promise.all(
      needsCountry.map(async (p) => {
        const country = await reverseGeocodeCountry(p.Lat, p.Longi);
        if (country) p.Country = country;
      })
    );
    return places;
  };

  const openAddPlacesPicker = (places) => {
    if (places.length === 0) {
      setAlertModalTitle("No New Places");
      setAlertModalMessage("No new places were found — everything in the selected guides is already in this guide.");
      setAlertModalButtons([{ Title: "OK", Method: null }]);
      setAlertModalShow(true);
      return;
    }
    // Values are indexes, not the places: the multiselect JSON-clones its
    // items, which would turn each Place into a plain object.
    window._importCandidates = places;
    const items = places.map((p, i) => ({ label: `${p.Name}${p.City ? " — " + p.City : ""}`, value: String(i) }));
    dispatch(slice1Actions.setMultiselectCallback({ value: addPlacesFromGuidesCallback }));
    dispatch(slice1Actions.setMultiselectItems({ value: items }));
    dispatch(slice1Actions.setMultiselectSelectedItems({ value: items }));
    dispatch(slice1Actions.setMultiselectMode({ value: "multi" }));
    dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    dispatch(slice1Actions.setMultiselectTitle({ value: "Select Places to Add" }));
    dispatch(slice1Actions.setShowMultiselect({ value: true }));
  };

  const addPlacesFromGuidesCallback = (selectedItems) => {
    if (!selectedItems || selectedItems.length === 0) return;
    const candidates = window._importCandidates || [];
    window._pendingAddPlaces = selectedItems.map((it) => candidates[Number(it.value)]).filter(Boolean);
    window._importCandidates = null;
    setImportPlacesVisited(false);
    setImportPlacesBucket(false);
    setImportPlacesChoice({ count: window._pendingAddPlaces.length });
  };

  const addPlacesFromGuidesFinish = () => {
    const places = window._pendingAddPlaces || [];
    const markVisited = importPlacesVisited;
    const markBucketList = importPlacesBucket;
    window._pendingAddPlaces = null;
    setImportPlacesChoice(null);
    if (places.length === 0) return;
    let added = 0;
    places.forEach((place) => {
      if (window.guide_obj.places.getSimilarPlaceInGuide(place) === null) {
        place.Visited = markVisited;
        place.BucketList = markBucketList;
        window.guide_obj.places.addPlace(place);
        added += 1;
      }
    });
    setTimeout(() => refreshGuide(), 100);
    setAlertModalTitle("Places Added");
    setAlertModalMessage(
      `Added ${added} place${added === 1 ? "" : "s"} to this guide, marked as ${markVisited ? "Visited" : "Not Visited"}${markBucketList ? " and added to your Bucket List" : ""}. Remember to save the guide to the cloud.`
    );
    setAlertModalButtons([{ Title: "OK", Method: null }]);
    setAlertModalShow(true);
  };

  addPlacesFromGuidesRef.current = handleAddPlacesFromGuides;

  const GuideDownloadCallback = (guide_info_id, guide_id) => {
    _DownloadGuide(guide_info_id, guide_id);
  };

  const _DownloadGuide = (guide_info_id, guide_id, guide_array) => {
    console.log("GuideDownloadCallback id:", guide_info_id);
    loadGuide(guide_info_id);

    let _user_info = JSON.parse(JSON.stringify(user_info));
    _user_info.last_guide_id = guide_info_id;
    _user_info.last_guide_time = DateTime.utc().toISO();
    dispatch(slice1Actions.setUserInfo({ value: _user_info }));
    if (_user_info.uid !== "guest") DataBase.updateUser(_user_info, user_info_id || _user_info.uid, updateUserCallback);
  };

  const SaveGuides =(guides, countries, cities, languages) => {
    if (GuideType === "Featured") {
      dispatch(slice1Actions.setGuideInfoArray({ value: JSON.parse(JSON.stringify(guides)) }));
      dispatch(slice1Actions.setGuideCountries({ value: countries }));
      dispatch(slice1Actions.setGuideCities({ value: cities }));
      dispatch(slice1Actions.setGuideLanguages({ value: languages }));
    } else {
      dispatch(slice1Actions.setGuideInfoArrayMine({ value: JSON.parse(JSON.stringify(guides)) }));
      dispatch(slice1Actions.setGuideCountriesMine({ value: countries }));
      dispatch(slice1Actions.setGuideCitiesMine({ value: cities }));
      dispatch(slice1Actions.setGuideLanguagesMine({ value: languages }));
    }
  };
  // A dragged Home/Map split is stored (and re-applied) as fixed px — fine
  // for the window it was set in, but that same split could push the bar
  // (and Map below it) below the fold entirely on a shorter window, e.g.
  // after the browser itself is resized/maximized differently, or the split
  // was saved on a taller screen and is now being restored on a shorter
  // one. Rather than trying to rescale the split proportionally (fragile —
  // has to exactly match the header row's own auto height), just fall back
  // to the CSS defaults (3fr/2fr, which always fit any viewport by
  // definition) whenever the current split wouldn't keep the bar visible.
  // Found 2026-09-14.
  const ensureHomeMapResizeBarVisible = () => {
    const bar = document.querySelector(".home-map-resize-bar");
    if (!bar) return; // not in the desktop grid right now (mobile mode)
    const rect = bar.getBoundingClientRect();
    if (rect.top < 0 || rect.bottom > window.innerHeight) {
      document.documentElement.style.removeProperty("--homeheight");
      document.documentElement.style.removeProperty("--mapheight");
      try { localStorage.removeItem("home_map_split"); } catch (e) { /* ignore */ }
    }
  };

  const reportWindowSize = (evt) => {
    //console.log("reportWindowSize", evt.currentTarget.innerWidth, evt.currentTarget.innerHeight);
    const minSize = Math.min(evt.currentTarget.innerWidth, evt.currentTarget.innerHeight);
    // setMobileMode(minSize < 500 ? true : false);
    // dispatch(slice1Actions.setMobileMode({ value: minSize < 500 ? true : false }));
    // setMobileMode(evt.currentTarget.innerHeight > evt.currentTarget.innerWidth ? true : false);
    setMobileMode( evt.currentTarget.innerWidth < 981 ? true : false);
    dispatch(slice1Actions.setMobileMode({ value: evt.currentTarget.innerWidth < 981 ? true : false }));
    ensureHomeMapResizeBarVisible();
  };

  // Desktop-only (see App.css's 981px+ .app-grid-no-side rule) drag handle
  // between the stacked home-panelx/map-panelx grid rows. Converts the
  // --homeheight/--mapheight CSS vars from their default 3fr/2fr ratio to
  // absolute px for the duration of the drag (and afterward, so the chosen
  // split sticks), then persists them so a reload doesn't reset the split.
  const handleHomeMapResizeStart = (downEvent) => {
    const homeEl = document.querySelector(".home-panelx");
    const mapEl = document.querySelector(".map-panelx");
    const barEl = downEvent.currentTarget;
    if (!homeEl || !mapEl) return;
    downEvent.preventDefault();
    const startY = downEvent.clientY;
    const startHomeHeight = homeEl.getBoundingClientRect().height;
    const startMapHeight = mapEl.getBoundingClientRect().height;
    barEl.classList.add("dragging");
    // Home's content renders as an <iframe> (Home.js's #home-content) — once
    // the cursor crosses into it mid-drag, the BROWSER hands subsequent
    // mousemove/mouseup events to the iframe's own document instead of this
    // window, so the drag would silently stop responding the moment it
    // moved up into Home (but not down into Map, which has no full-panel
    // iframe). Disabling pointer events on both panels for the duration of
    // the drag keeps the cursor's events on this window throughout, no
    // matter which panel it's over. Found 2026-09-14.
    const prevHomePointerEvents = homeEl.style.pointerEvents;
    const prevMapPointerEvents = mapEl.style.pointerEvents;
    homeEl.style.pointerEvents = "none";
    mapEl.style.pointerEvents = "none";
    homeMapResizeRef.current = { startY, startHomeHeight, startMapHeight };

    // Never let a drag squeeze a panel down to a sliver that leaves the bar
    // sitting flush against the header/bottom edge with no usable content
    // showing either side of it.
    const MIN_PANEL_HEIGHT = 48;
    // Clamp the DELTA itself (not each resulting height independently) so
    // the two heights always keep summing to the original total — clamping
    // them separately let one side hit its floor while the other kept
    // growing past it, so the pair silently no longer fit in the space
    // actually available (found via the same drift that caused the
    // off-screen-after-resize bug below). Found 2026-09-14.
    const minDelta = MIN_PANEL_HEIGHT - startHomeHeight;
    const maxDelta = startMapHeight - MIN_PANEL_HEIGHT;
    const onMove = (moveEvent) => {
      const drag = homeMapResizeRef.current;
      if (!drag) return;
      const rawDelta = moveEvent.clientY - drag.startY;
      const delta = Math.min(maxDelta, Math.max(minDelta, rawDelta));
      document.documentElement.style.setProperty("--homeheight", `${startHomeHeight + delta}px`);
      document.documentElement.style.setProperty("--mapheight", `${startMapHeight - delta}px`);
    };
    const onUp = () => {
      barEl.classList.remove("dragging");
      homeMapResizeRef.current = null;
      homeEl.style.pointerEvents = prevHomePointerEvents;
      mapEl.style.pointerEvents = prevMapPointerEvents;
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      try {
        localStorage.setItem("home_map_split", JSON.stringify({
          homeheight: document.documentElement.style.getPropertyValue("--homeheight"),
          mapheight: document.documentElement.style.getPropertyValue("--mapheight"),
        }));
      } catch (e) { /* localStorage unavailable — split just won't persist */ }
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  };

  const handleLoad = () => {
    window.addEventListener("resize", reportWindowSize);
    //const minSize = Math.min(window.innerWidth, window.innerHeight);
    //setMobileMode(minSize < 500 ? true : false);
    //setMobileMode(window.innerHeight > window.innerWidth ? true : false);
    setMobileMode(window.innerWidth < 800 ? true : false);
    dispatch(slice1Actions.setMobileMode({ value: window.innerWidth < 981 ? true : false }));
    setTimeout(function () {
      // Hide the address bar!
      window.scrollTo(0, 1);
    }, 100);
  };

  let r = null;
  if (GuideSettings.hide_schedule === true || HideSchedule === true) {
    r = document.querySelector(":root");
    r.style.setProperty("--schedwidth", "0px");
    r.style.setProperty("--schedule-menu", "0px");
    r.style.setProperty("--scheduleheightfixed", "0px");
  } else {
    r = document.querySelector(":root");
    r.style.setProperty("--schedwidth", "clamp(220px, 22vw, 350px)");
    r.style.setProperty("--schedule-menu", "85px");
    r.style.setProperty("--scheduleheightfixed", "500px");
  }
  if (HidePlaces === true) {
    r = document.querySelector(":root");
    r.style.setProperty("--placeswidth", "0px");
    r.style.setProperty("--places-menu", "0px");
    r.style.setProperty("--placesheightfixed", "0px");
  } else {
    r = document.querySelector(":root");
    r.style.setProperty("--placeswidth", "clamp(260px, 22vw, 350px)");
    r.style.setProperty("--places-menu", "70px");
    r.style.setProperty("--placesheightfixed", "500px");
  }
  if (HideMap === true) {
    r = document.querySelector(":root");
    r.style.setProperty("--mapheight", "0px");
    r.style.setProperty("--mapheightfixed", "0px");
    r.style.setProperty("--homeheight", "3fr");
  } else {
    r = document.querySelector(":root");
    r.style.setProperty("--mapheight", "2fr");
    r.style.setProperty("--mapheightfixed", "500px");
  }
  if (HideHome === true) {
    r = document.querySelector(":root");
    r.style.setProperty("--homeheight", "0px");
    r.style.setProperty("--mapheight", "2fr");
    r.style.setProperty("--homeheightfixed", "0px");
  } else {
    r = document.querySelector(":root");
    r.style.setProperty("--homeheight", "3fr");
    r.style.setProperty("--homeheightfixed", "500px");
  }
  if (HideSideMenu === true) {
    r = document.querySelector(":root");
    r.style.setProperty("--sidemenupanel", "0px");
  } else {
    r = document.querySelector(":root");
    r.style.setProperty("--sidemenupanel", "80px");
  }

  window.web_app = true;
  if (!window.mapRef) window.mapRef = null;
  if (!window.DirectionsWaypointsLocation) window.DirectionsWaypointsLocation = [];
  if (!window.DirectionsFromLocation) window.DirectionsFromLocation = null;
  if (!window.DirectionsToLocation) window.DirectionsToLocation = null;
  if (!window.LocationWatchID) window.LocationWatchID = null;
  //window.GuidesOrPlaces = "Places";
  //window.hiddenPlacesToShow = [];

  let side_panel = false;
  let grid_sel = "side";
  if (HomeFullScreen === true) grid_sel = "map";
  //console.log("MobileMode", MobileMode);
  if (MapFullScreen === true && _MobileMode === true)
    return (
      <div className={`app-mobile-full-screen`} style={{ paddingTop: conflictBannerPadding }}>
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="mobile-web-app-capable" content="yes" />
        <ConflictPreviewBanner />
        {CurrentAppScreen === "Map" ? (
          <div className="app-mobile-main-full-screen">
            {GuideLoaded ? <Map callback={GuideDownloadCallback} /> : null}
          </div>
        ) : null}
        {ShowOffcanvas ? (
          <Offcanvas
            show={ShowOffcanvas}
            onHide={() => dispatch(slice1Actions.setShowOffcanvas({ value: false }))}
            placement={"bottom"}
            className="directions-offcanvas-full"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Directions</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <DirectionsDialogComponent></DirectionsDialogComponent>
            </Offcanvas.Body>
          </Offcanvas>
        ) : null}
      </div>
    );

  // App's own dialogs, rendered in every layout (2026-10-20): the phone
  // layout (< 981 px) and full-screen map returned without them, so every
  // App.js alert — "Places Added", "No Other Guides"… — was invisible there.
  const appDialogs = (
    <>
      <ReportGuideModal />
      <RenameFollowUpModal />
      {importPlacesChoice ? (
        <Modal show onHide={() => { window._pendingAddPlaces = null; setImportPlacesChoice(null); }} centered size="sm">
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 18 }}>Import {importPlacesChoice.count} place{importPlacesChoice.count === 1 ? "" : "s"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <label style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8, cursor: "pointer" }}>
              <input type="checkbox" checked={importPlacesVisited} onChange={(e) => setImportPlacesVisited(e.target.checked)} />
              Mark as visited
            </label>
            <label style={{ display: "flex", gap: 8, alignItems: "center", cursor: "pointer" }}>
              <input type="checkbox" checked={importPlacesBucket} onChange={(e) => setImportPlacesBucket(e.target.checked)} />
              Add to my Bucket List too
            </label>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-outline-secondary btn-sm" onClick={() => { window._pendingAddPlaces = null; setImportPlacesChoice(null); }}>
              Cancel
            </button>
            <button className="btn btn-primary btn-sm" onClick={addPlacesFromGuidesFinish}>
              Add
            </button>
          </Modal.Footer>
        </Modal>
      ) : null}
      {AlertModalShow ? (
        <AlertModal
          show={AlertModalShow}
          onHide={() => setAlertModalShow(false)}
          attributes={{
            onHide: () => setAlertModalShow(false),
            AlertModalTitle: AlertModalTitle,
            AlertModalMessage: AlertModalMessage,
            AlertModalButtons: AlertModalButtons,
          }}
        />
      ) : null}
    </>
  );

  if (_MobileMode === true)
    return (
      <div className={`app-mobile`} style={{ paddingTop: conflictBannerPadding }}>
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="mobile-web-app-capable" content="yes" />
        <ConflictPreviewBanner />
        {ShowWelcomeScreen ? <WelcomeScreen /> : null}
        {MapFullScreen === false ? (
          <div className="app-mobile-footer">
            <MobileNavBar />
          </div>
        ) : null}
        {CurrentAppScreen === "Home" && GuideLoaded && GuidesOrPlaces === "Places" ? (
          <div className="app-mobile-subheader">
            <GuideNameBar />
          </div>
        ) : null}
        {(CurrentAppScreen === "Places" || CurrentAppScreen === "Map") && GuidesOrPlaces === "Places" && !HidePlaces ? (
          <div className="app-mobile-subheader">
            <PlacesHeader />
          </div>
        ) : null}
        {GuidesOrPlaces === "Guides" && !HidePlaces ? (
          <div className="app-mobile-subheader">
            <GuidesHeader />
          </div>
        ) : null}
        {CurrentAppScreen === "Schedule" ? (
          <div className="app-mobile-subheader">
            <ScheduleHeader />
          </div>
        ) : null}
        {/* {CurrentAppScreen === "Map" ? (
        <div className="app-mobile-subheader">
        <MobileHeader />
        </div>
        ) : null} */}
        {CurrentAppScreen === "Home" && GuidesOrPlaces === "Places" ? (
          <div className="app-mobile-main">
            <Home />
          </div>
        ) : null}
        {CurrentAppScreen === "Places" && GuidesOrPlaces === "Places" ? (
          <div className="app-mobile-main">
            <Places />
          </div>
        ) : null}
        {GuidesOrPlaces === "Guides" ? (
          <div className="app-mobile-main">
            <GuideDownloadComponent
              user_info={user_info}
              guide_sort_option={GuideSortOption}
              set_guide_sort_option={SetGuideSortOption}
              callback={GuideDownloadCallback}
              copy_from_guide={handleChooseCopyMode}
              save_guides={SaveGuides}
              mode={GuideDownloadMode}
              guide_search_text={GuideSearchText}
              guide_meta={guide_meta}
              guide_order_by={GuideOrderBy}
              guide_order_ascending={GuideOrderAscending}
              guide_info_array={GuideType === "Featured" ? GuideInfoArray : GuideType === "Viewed" ? ViewedGuides : GuideInfoArrayMine}
              guide_info_array_viewed={ViewedGuides}
              guide_countries_selected={GuideType === "Featured" ? GuideCountriesSelected : GuideCountriesMineSelected}
              guide_cities_selected={GuideType === "Featured" ? GuideCitiesSelected : GuideCitiesMineSelected}
              guide_language_selected={GuideType === "Featured" ? GuideLanguageSelected : GuideLanguageMineSelected}
              guide_type={GuideType}
              mobile_mode={true}
              on_select_guide_type={(type) =>
                dispatch(slice1Actions.setGuidesOrPlaces({ value: "Guides", GuideType: type }))
              }
            />
          </div>
        ) : null}
        {CurrentAppScreen === "Schedule" && GuidesOrPlaces === "Places" ? (
          <div className="app-mobile-main">
            <SchedulePanel />
          </div>
        ) : null}
        {CurrentAppScreen === "Map" && GuidesOrPlaces === "Places" ? (
          <div className="app-mobile-main">{GuideLoaded ? <Map callback={GuideDownloadCallback} /> : null}</div>
        ) : null}
        {GuidesOrPlaces === "Wanderlist" ? (
          <div className="app-mobile-main">
            <GeoCharts
              show={true}
              embedded={true}
              onHide={() => dispatch(slice1Actions.setGuidesOrPlaces({ value: "Places", GuideType: GuideType }))}
            />
          </div>
        ) : null}
        {GuidesOrPlaces === "You" ? (
          <div className="app-mobile-main">
            <YouPanel />
          </div>
        ) : null}
        {ShowOffcanvas ? (
          <Offcanvas
            show={ShowOffcanvas}
            onHide={() => dispatch(slice1Actions.setShowOffcanvas({ value: false }))}
            placement={"bottom"}
            className="directions-offcanvas-full"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Directions</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <DirectionsDialogComponent></DirectionsDialogComponent>
            </Offcanvas.Body>
          </Offcanvas>
        ) : null}
        {MapFullScreen === false ? (
          <div className="app-mobile-header">
            <MobileBottomNavBar />
          </div>
        ) : null}
        <InstallPrompt />
        {appDialogs}
      </div>
    );

  if (MapFullScreen === true)
    return (
      <div className={`app-grid-map-fullscreen`} style={{ paddingTop: conflictBannerPadding }}>
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="mobile-web-app-capable" content="yes" />
        <ConflictPreviewBanner />
        <div id="map-start" className="map-panelx">
          {GuideLoaded ? <Map callback={GuideDownloadCallback} /> : null}
        </div>
        {ShowOffcanvas ? (
          <Offcanvas
            show={ShowOffcanvas}
            onHide={() => dispatch(slice1Actions.setShowOffcanvas({ value: false }))}
            placement={"end"}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Directions</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <DirectionsDialogComponent></DirectionsDialogComponent>
            </Offcanvas.Body>
          </Offcanvas>
        ) : null}
        {appDialogs}
      </div>
    );
  return (
    <div className={`app-grid${side_panel === true ? "" : `-no-${grid_sel}`}`} style={{ paddingTop: conflictBannerPadding }}>
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="mobile-web-app-capable" content="yes" />
      <ConflictPreviewBanner />
      {ShowWelcomeScreen ? <WelcomeScreen /> : null}
      {/* <Helmet>
        <meta charSet="utf-8" />
        <title>Andiamo Places. Create Travel Guides and Journals for Free</title>
        <meta name="description" content="Create Travel Guides and Journals for Free" />
        <meta name="keywords" content="travel, guide, travel guide, travel blog, travel journal" />
        <meta
          property="og:image"
          content="https://firebasestorage.googleapis.com/v0/b/liquidguides-2ce60.appspot.com/o/fb_images%2FE2Fqqu9FWDgTdpOzdKQOKEdo6wA3%2F2022-02-23T11%3A59%3A45.636%2B01%3A00_m"
        />
      </Helmet> */}

      {GuidesOrPlaces === "Guides" && !HidePlaces ? (
        <div id="places-start" className="places-menu-panel">
          <GuidesHeader />
        </div>
      ) : null}
      {GuidesOrPlaces !== "Guides" && !HidePlaces ? (
        <div id="places-start" className="places-menu-panel">
          <PlacesHeader />
        </div>
      ) : null}
      <div id="home-start" className="main-menu-panel">
        {/* <MobileBottomNavBar /> */}
        <div className="sticky-header">
          <MobileBottomNavBar />
        </div>
      </div>
      <div id="schedule-start" className="schedule-menu-panel">
        <ScheduleHeader />
      </div>

      {GuidesOrPlaces === "Guides" ? (
        <div className="places-panel">
          <GuideDownloadComponent
            user_info={user_info}
            guide_sort_option={GuideSortOption}
            set_guide_sort_option={SetGuideSortOption}
            callback={GuideDownloadCallback}
            copy_from_guide={handleChooseCopyMode}
            save_guides={SaveGuides}
            mode={GuideDownloadMode}
            guide_search_text={GuideSearchText}
            guide_meta={guide_meta}
            guide_order_by={GuideOrderBy}
            guide_order_ascending={GuideOrderAscending}
            guide_info_array={GuideType === "Featured" ? GuideInfoArray : GuideInfoArrayMine}
            guide_countries_selected={GuideType === "Featured" ? GuideCountriesSelected : GuideCountriesMineSelected}
            guide_cities_selected={GuideType === "Featured" ? GuideCitiesSelected : GuideCitiesMineSelected}
            guide_language_selected={GuideType === "Featured" ? GuideLanguageSelected : GuideLanguageMineSelected}
            guide_type={GuideType}
          />
        </div>
      ) : (
        <div className="places-panel">
          <Places />
        </div>
      )}
      <div className="home-panelx">
        {GuideLoaded ? <GuideNameBar /> : null}
        <Home />
      </div>
      <div className="home-map-resize-bar" onMouseDown={handleHomeMapResizeStart} title="Drag to resize" />
      <div className="schedule-panelx">
        <SchedulePanel />
      </div>
      <div id="map-start" className="map-panelx">
        {GuideLoaded ? <Map callback={GuideDownloadCallback} /> : null}
      </div>
      <div className="side-menu-panel">{HideSideMenu !== true ? <VerticalSidebar /> : null}</div>
      {ShowOffcanvas ? (
        <Offcanvas
          show={ShowOffcanvas}
          onHide={() => dispatch(slice1Actions.setShowOffcanvas({ value: false }))}
          placement={"end"}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Directions</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <DirectionsDialogComponent></DirectionsDialogComponent>
          </Offcanvas.Body>
        </Offcanvas>
      ) : null}
      {/* {side_panel === true ? (
        <div className="side-menu-panel">
          <VerticalSidebar />
        </div>
      ) : null} */}

      {/* <div className="scroll-panel">
        <div className="scroll-icon">
          <i className="fxa fa-arrows-v"></i>
        </div>
      </div> */}
      {/* <div className="bottom-menu-panel">
        <h1>Bottom Panel</h1>
      </div> */}
      {/* <HTMLReader show={ShowHTMLReader} onHide={() => dispatch(slice1Actions.setShowHTMLReader({ value: false }))} /> */}

      {/* <MultiSelectModal
        show={ShowMultiselect}
        onHide={() => dispatch(slice1Actions.setShowMultiselect({ value: false }))}
        MultiselectItems={MultiselectItems}
        MultiselectSelectedItems={MultiselectSelectedItems}
        MultiselectMode={MultiselectMode}
        MultiselectCallback={MultiselectCallback}
        MultiselectTitle={MultiselectTitle}
        MultiselectSearchText={MultiselectSearchText}
      /> */}
      {appDialogs}
    </div>
  );
}

export default App;
